import { createStyles, makeStyles } from "@mui/styles";

export const OfferCharacteristicSharedInputStyles = makeStyles(() =>
    createStyles({
        tooltip: {
            listStyle: "inside",
        },
        CheeckyAlert: {
            width: "100%",
        },
        CheeckyAlertScenario: {
            marginBottom: 16,
        },
    })
);
